export const engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdSteps =
  "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id/steps";
